var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 15,
    viewBox: "0 0 23 15",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.047 1)",
    stroke: "currentColor",
    strokeWidth: 1.5,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.376,
    height: 4.63,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.623,
    width: 8.376,
    height: 12.279,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    y: 7.724,
    width: 8.376,
    height: 4.63,
    rx: 1.5
  }))));
}
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjNweCIgaGVpZ2h0PSIxNXB4IiB2aWV3Qm94PSIwIDAgMjMgMTUiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+R3JvdXAgMTIgQ29weTwvdGl0bGU+CiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iR3JvdXAtMTItQ29weSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMS4wNDY2MTEsIDEuMDAwMDAwKSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMS41Ij4KICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZSIgeD0iLTMuNTUyNzEzNjhlLTE1IiB5PSI4Ljc5Mjk2NjM2ZS0xNCIgd2lkdGg9IjguMzc2NDMwMyIgaGVpZ2h0PSI0LjYyOTgwNDQyIiByeD0iMS41Ij48L3JlY3Q+CiAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUtQ29weS02IiB4PSIxMS42MjI3OTY5IiB5PSI2LjEyODQzMTFlLTE0IiB3aWR0aD0iOC4zNzY0MzAzIiBoZWlnaHQ9IjEyLjI3ODU2ODkiIHJ4PSIxLjUiPjwvcmVjdD4KICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZS1Db3B5IiB4PSItMy41NTI3MTM2OGUtMTUiIHk9IjcuNzIzNzQ4OCIgd2lkdGg9IjguMzc2NDMwMyIgaGVpZ2h0PSI0LjYyOTgwNDQyIiByeD0iMS41Ij48L3JlY3Q+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=";
export { SvgMore as ReactComponent };